import { EQUIP_STATUS, dueState } from "./equipmentMeta";

const chip = (active) =>
  `text-xs font-bold tracking-tight px-3 py-1.5 rounded-full border transition-colors flex items-center gap-1.5 ${active ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-zinc-600 border-zinc-300 hover:border-zinc-900"}`;

const Count = ({ n }) => <span className="opacity-60 font-mono text-[10px]">{n}</span>;

export const filterCatalogue = (list, status, due) =>
  list.filter((e) => (status === "all" || e.status === status) && (due === "all" || dueState(e) === due || (due === "soon" && dueState(e) === "overdue")));

export const CatalogueFilters = ({ items, status, setStatus, due, setDue }) => {
  const overdue = items.filter((e) => dueState(e) === "overdue").length;
  const soon = items.filter((e) => dueState(e)).length;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mb-5">
      <div className="flex flex-wrap gap-2" data-testid="equipment-status-filter">
        <button onClick={() => setStatus("all")} data-testid="status-filter-all" className={chip(status === "all")}>All <Count n={items.length} /></button>
        {Object.entries(EQUIP_STATUS).map(([k, s]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`status-filter-${k}`} className={chip(status === k)}>
            {s.label} <Count n={items.filter((e) => e.status === k).length} />
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2" data-testid="equipment-due-filter">
        <button onClick={() => setDue("all")} data-testid="due-filter-all" className={chip(due === "all")}>Any date</button>
        <button onClick={() => setDue("overdue")} data-testid="due-filter-overdue"
          className={due === "overdue" ? chip(true).replace("bg-zinc-900", "bg-red-600").replace("border-zinc-900", "border-red-600") : chip(false)}>
          Overdue <Count n={overdue} />
        </button>
        <button onClick={() => setDue("soon")} data-testid="due-filter-soon"
          className={due === "soon" ? chip(true).replace("bg-zinc-900", "bg-amber-500").replace("border-zinc-900", "border-amber-500") : chip(false)}>
          Due in 30 days <Count n={soon} />
        </button>
      </div>
    </div>
  );
};
